























































































































































































































import { Component, Vue, Watch } from 'nuxt-property-decorator'
import PrivacyPolicyConsent from '~/components/Other/PrivacyPolicyConsent.vue'
import { ContactSubmissionForm } from '~/models/ContactModels'
import * as FirebaseService from '../../services/FirebaseService'

import {
  ValidationObserver,
  ValidationProvider,
  setInteractionMode
} from 'vee-validate'

setInteractionMode('lazy')

@Component({
  name: 'ContactForm',
  components: {
    PrivacyPolicyConsent,
    ValidationProvider,
    ValidationObserver
  },
  mixins: []
})
export default class extends Vue {
  form: ContactSubmissionForm = {
    FirstName: '',
    LastName: '',
    Email: '',
    Company: '',
    Phone: '',
    Subject: '',
    Message: '',
    ConsentGeneral: false,
    UserLanguage: ''
  }

  loading: boolean = false
  showSuccessAlert: boolean = false
  showErrorAlert: boolean = false

  get userLocale() {
    return this.$i18n.locale
  }

  get reasonItems(): Array<string> {
    return [
      this.$tt('OptionSubjectProjectManager'),
      this.$tt('OptionSubjectSales'),
      this.$tt('OptionSubjectGeneral')
    ]
  }

  get rules(): object {
    return ContactSubmissionForm.rules
  }

  async submit() {
    this.showSuccessAlert = false
    this.showErrorAlert = false
    // @ts-ignore
    if (await this.$refs.observer.validate()) {
      this.loading = true
      try {
        console.log(this.form)
        const result = await this.postData(this.form)
        this.showSuccessAlert = true
        this.resetForm()
      } catch (err) {
        console.log(err)
        this.showErrorAlert = true
      } finally {
        this.loading = false
      }
    }
  }

  async postData(data) {
    return await this.$axios.post('/api/contact/submit', this.form)
  }

  resetForm() {
    // @ts-ignore
    this.$refs.observer.reset()
  }

  mounted() {
    this.form.Subject = this.reasonItems[0]
    this.form.UserLanguage = this.$i18n.locale
  }
}
